<template>
    <li class="py-2 pl-10 pr-4 cursor-pointer relative"
        :class="[
            selected ? (color ? 'text-'+color+'-900 bg-'+color+'-50' : '') : 'text-gray-900 hover:bg-gray-50',
        ]"
    >
        <slot />

        <span
            v-if="selected"
            class="absolute inset-y-0 left-0 flex items-center pl-3"
            :class="{
                ['text-'+color+'-600'] : color,
                ['text-'+colorSvg+'-600'] : colorSvg && !color
            }"
        >
            <SvgIcon
                name="check"
                :size="18"
            />
        </span>
    </li>
</template>

<script>
import SvgIcon from 'UI/SvgIcon';
export default {
    props: {
        selected: { type: Boolean },
        color: {
            type: [String, Boolean],
            default: 'yellow'
        },
        colorSvg: {
            type: String,
            default: 'yellow'
        }
    },
    components: {
        SvgIcon,
    }
}
</script>
